<template>
  <div class="header-box">
    <div class="header">
      <div class="content">
        <div class="logo full-left">
          <router-link to="/"><img src="../../../static/image/logo.png" style="height: 30px;" alt=""></router-link>
        </div>

        <div class="login-bar full-right">
          <ul class="nav full-left">
            <li :class="active == 'home' ? 'active' : ''" @click="switchTab('home')"><span>首页</span></li>
            <li :class="active == 'goods' ? 'active' : ''" @click="switchTab('goods')"><span>网校课程</span></li>
            <li :class="active == 'teacher' ? 'active' : ''" @click="switchTab('teacher')"><span>讲师团队</span></li>
            <li :class="active == 'about' ? 'active' : ''" @click="switchTab('about')"><span>关于我们</span></li>
            <li :class="active == 'downApp' ? 'active' : ''" @click="switchTab('downApp')"><span>手机APP</span></li>
          </ul>
          <div v-if="!isLogin" class="login-box full-left" @click="loginVisible = true" style="font-size: 15px;font-size: 15px;
    background: #399df6;
    padding: 10px 10px;
    color: #fff;
    border-radius: 5px;">
            <span>登录</span>
            &nbsp;|&nbsp;
            <span>注册</span>
          </div>
          <div v-else class="fl">
            <div class="fl">
              <el-button type="primary" size="medium" @click="goLearn" style="margin-top: 15px;">学习中心</el-button>
            </div>
            <el-dropdown style="margin-left: 20px;">
              <span class="el-dropdown-link">
                <div class="avatar">
                  <img class="avatarImg" :src="avatarImg">
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item><span @click="goOrderList()"><i
                      class="el-icon-goods"></i>我的订单</span></el-dropdown-item>
                <!-- <el-dropdown-item><span><i class="el-icon-location-outline"></i>收货地址</span> </el-dropdown-item> -->
                <el-dropdown-item><span @click="exit"><i class="el-icon-switch-button"></i>退出</span></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="loginVisible" width="460px">
      <Login></Login>
    </el-dialog>
  </div>
</template>

<script>

import Login from '@/components/Login.vue'

import {
  getLocalStorage,
  removeCookie,
  removeLocalStorage
} from '@/utils/util.js';

import {
  getByUrl
  // getByParam
} from '@/api/api.js';

export default {
  name: "Header",
  components: {
    Login
  },
  data() {
    return {
      loginVisible: false,
      active: 'home',
      isLogin: false,
      userInfo: {},
      avatarImg: 'https://static.xmygjykj.com/user/default_avatar.jpg'
    }
  },

  mounted() {

    var url = window.location.href;
    console.log(window.location.href)
    if (url.indexOf('home') > -1) {
      console.log('home')
      this.active = 'home'
    } else if (url.indexOf('good') > -1) {
      console.log('goods')
      this.active = 'goods'
    } else if (url.indexOf('teacher') > -1) {
      console.log('teacher')
      this.active = 'teacher'
    } else if (url.indexOf('about') > -1) {
      console.log('about')
      this.active = 'about'
    } else if (url.indexOf('downApp') > -1) {
      console.log('downApp')
      this.active = 'downApp'
    }
    let token = getLocalStorage('token')
    if (token) {
      this.checkToken();
    }


  },
  methods: {
    goLearn(){
      window.open('https://study.xmygjykj.com/?key=yg_zj&code='+getLocalStorage('token')+'#/login', '_blank');
    },
    goOrderList() {
      console.log('goOrderList')
      this.$router.push({
        path: '/order/list',
      })
    },
    showLogin() {
      this.loginVisible = true;
    },
    switchTab(tabId) {
      if (tabId == 'home') {
        this.$router.push({
          path: '/home',
        })
      } else if (tabId == 'goods') {
        this.$router.push({
          path: '/goods',
        })
      } else if (tabId == 'teacher') {
        this.$router.push({
          path: '/teacher',
        })
      } else if (tabId == 'about') {
        this.$router.push({
          path: '/about',
        })
      } else if (tabId == 'downApp') {
        this.$router.push({
          path: '/downApp',
        })
      }

    },
    exit() {
      console.log('退出')
      removeCookie('token')
      removeLocalStorage('token')
      location.reload();
    },
    checkToken() {
      getByUrl('/web/index/token/check').then(res => {
        if (!res.data) {
          removeCookie('token')
          removeLocalStorage('token')
        } else {
          this.isLogin = true;
          this.userInfo = JSON.parse(getLocalStorage('info'));
          console.log('userInfo', this.userInfo)
          if (this.userInfo.avatarUrl) {
            this.avatarImg = this.userInfo.avatarUrl;
          }
        }
      })
    }


  }
}
</script>

<style scoped>
.header-box {
  height: 70px;
}

.header {
  width: 100%;
  height: 70px;
  /* box-shadow: 0 0.5px 0.5px 0 #c9c9c9; */
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 2000;
  background: #fff;
}

.header .content {
  max-width: 1500px;
  width: 100%;
  margin: 0 auto;
}

.header .content .logo {
  height: 70px;
  line-height: 70px;
  margin-right: 50px;
  cursor: pointer;
  /* 设置光标的形状为爪子 */
}

.header .content .logo img {
  vertical-align: middle;
}

.header .nav li {
  float: left;
  height: 68px;
  line-height: 70px;
  margin-right: 30px;
  font-size: 16px;
  color: #4a4a4a;
  cursor: pointer;
}

.header .nav li span {
  padding-bottom: 16px;
  padding-left: 5px;
  padding-right: 5px;
}

.header .nav li span a {
  display: inline-block;
}

.header .nav li .this {
  color: #4a4a4a;
  border-bottom: 4px solid #ffc210;
}

.header .nav li:hover span {
  color: #000;
}

.header .login-bar {
  height: 70px;
}

.header .login-bar .shop-cart {
  margin-right: 20px;
  border-radius: 17px;
  background: #f7f7f7;
  cursor: pointer;
  font-size: 14px;
  height: 28px;
  width: 88px;
  margin-top: 30px;
  line-height: 32px;
  text-align: center;
}

.header .login-bar .shop-cart:hover {
  background: #f0f0f0;
}

.header .login-bar .shop-cart img {
  width: 15px;
  margin-right: 4px;
  margin-left: 6px;
}

.header .login-bar .shop-cart span {
  margin-right: 6px;
}

.header .login-bar .login-box {
  margin-top: 15px;
}

.header .login-bar .login-box span {
  /* color: #4a4a4a; */
  cursor: pointer;
}

/* .header .login-bar .login-box span:hover {
  color: #000000;
} */

.active {
  border-bottom: 2px solid #3a9dff;
}

.avatar {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  cursor: pointer;
  margin-top: 20px;
}

.avatarImg {
  width: 32px;
  height: 32px;
  border-radius: 18.9px;
}
</style>
